import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { swalError, swalDesition } from 'src/app/shared/config/swalCommon';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { swalCustom } from '../../../shared/config/swalCommon';
import { LogsService, PaymentCapacityService, UserService } from 'src/app/services/services.index';
import { LogsNav, PayCapReason } from 'src/app/interfaces/interfaces.index';
import { PaymentCapacity } from '../../../interfaces/payment-capacity';

@Component({
  selector: 'app-solicitud-detalles',
  templateUrl: './solicitud-detalles.component.html',
  styleUrls: ['./solicitud-detalles.component.css']
})
export class SolicitudDetallesComponent implements OnInit {
  cPago: PayCapReason = {} as PayCapReason;
  paymentView: PaymentCapacity = {} as PaymentCapacity;
  mode: string;
  id: number;
  viewPayment: boolean;
  adjudgedUserId = JSON.parse(sessionStorage.getItem('AdjudgedUserId')) as number;

  constructor(
    public router: Router,
    private cPService: PaymentCapacityService,
    private SpinnerService: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private logsService: LogsService,
    private userService: UserService
  ) {
    this.activatedRoute.paramMap.subscribe((res: any) => {
      this.mode = res.params.mode;
      this.id = res.params.id;
    });
  }

  ngOnInit(): void {
    this.addLogsNav();
  }

  addLogsNav(){
    const logNav: LogsNav = {
      logType: 'Log de Navegación',
      visitedPage: location.href,
      userId: this.userService.user.id,
      petitionId: 0,
      stepCompleted: ''
    };

  }

  consult() {
    this.SpinnerService.show();
    this.cPService.getPaymentResultbyId(this.id.toString()).subscribe(res => {

      this.cPago = res;
      this.SpinnerService.hide();
    }, err => this.handleError(err));
    this.cPService.getPaymentByPetition(this.id, this.adjudgedUserId)
    .subscribe(py => this.paymentView = py, err => this.handleError(err));
  }

  finishPetition(close?: boolean) {
    const desition = (close) ? swalDesition('Cierre', '¿Desea cerrar definitivamente la solicitud?') : swalDesition('Cargar de nuevo', '¿Desea cargar se nuevo la solicitud?');
    const message = (close) ? swalCustom('Rechazado', 'Envío de Cierre del proceso al Cliente') : swalCustom('Aprovado', 'Envió Aprobación con Experiencia digital para el cliente');
    Swal.fire(desition).then(res => {
      if (res.value) {
        this.SpinnerService.show();
        this.cPService.rexamineOrClose(this.id.toString(), close).subscribe(() => {
          this.SpinnerService.hide();
          Swal.fire(message);
        }, err => this.handleError(err));
      }
    });
  }

  viewForm = (event) => this.viewPayment = event.target.checked;

  backPage() {
    const prevUrl = document.referrer;
    if (prevUrl.indexOf(window.location.host) !== -1) { window.history.back(); }
    else { this.router.navigate(['']); }
  }

  handleError = (err) => {
    this.SpinnerService.hide();
    Swal.fire(swalError('Ha ocurrido un error', err?.userMessage));
  }
}
